import React, { useContext } from 'react';
import experienciasContext from '../../context/experiencias/experienciasContext';
import urlImages from '../../config/urlImages';

const Banner = () => {

    const { banner } = useContext(experienciasContext);

    return (
        <section className='first_section' id="banner_quienes_somos" style={{backgroundImage: `url("${urlImages}uploads/experiencias/${banner?.img}")`}}> 
            <div>
                <h1>{banner?.title}</h1>
                <p>
                    {banner?.body}
                </p>
            </div>
        </section>
    );
}

export default Banner;